export const ALL_BRANDS_ITEM = { id: "static", name: "Смотреть все бренды", alias: "" };
export const COUNT_ITEMS_SLIDE = 24;